// extracted by mini-css-extract-plugin
export default {"container":"video-page_container__l-czc","container__wrapper":"video-page_container__wrapper__vGvDi"};